import { Injectable } from "@angular/core";
import { Firestore, doc } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { BehaviorSubject } from "rxjs";
import { tap } from "rxjs/operators";
import { Units } from "src/interfaces/enums.model";
import { Locale } from "src/interfaces/locale.model";

@Injectable({
  providedIn: "root",
})
export class LocaleService {
  private localeSubject = new BehaviorSubject<Locale | null>(null);
  public locale$ = this.localeSubject.asObservable();

  constructor(private store: Firestore) {}

  public subscribeToLocale(id: string): void {
    console.log("LocaleService | Subscribing to locale:", id);
    const docRef = doc(this.store, "locale", id);
    docData(docRef).pipe(
      tap((data: any) => {
        const locale = this.transformLocaleData(data);
        this.localeSubject.next(locale);
      })
    ).subscribe();
  }

  public getLocale(): Locale | null {
    return this.localeSubject.getValue();
  }

  private transformLocaleData(data: any): Locale {
    const unitsMap = new Map<Units, string>();

    if (data.units && typeof data.units === "object") {
      for (const [key, value] of Object.entries(data.units)) {
        const unitKey = Units[key as keyof typeof Units];
        if (unitKey !== undefined && typeof value === "string") {
          unitsMap.set(unitKey, value);
        }
      }
    }

    const languages: string[] = Array.isArray(data.languages)
      ? (data.languages as unknown[]).filter((lang: unknown): lang is string => typeof lang === "string")
      : [];

    return {
      code: data.code,
      currency: data.currency,
      time: data.time,
      units: unitsMap,
      languages: languages,
      decimal: data.decimal,
    };
  }
}